export default __webpack_public_path__ + "assets/images/4756740ec40f749bd61e6ea4f9029eb0.webp";